import {chartColors as ChartColors} from "../../utils/ChartColors";
import {convertCurrencyFormatPositiveNegative, RaikoLabel} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import "./PieChartLineInfo.scss"

export default function PieChartLineInfo(
    {
        color = ChartColors.blue,
        title,
        value
    }) {

    return (
        <div className={"basePieChartLineInfoContainer"}>
            <div className={css`background: ${color}`}/>
            <RaikoLabel text={title} className={css`flex-grow: 1;`}/>
            <RaikoLabel text={convertCurrencyFormatPositiveNegative(value)}/>
        </div>
    )

}


